import React from 'react'

const Activities = () => (
  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.73 19.1">
    <path
      d="M10.86 18.04l8.37-8.37a5.08 5.08 0 1 0-7.67-6.49l-.7 1.16-.68-1.16A5.08 5.08 0 0 0 .75 5.84a5.14 5.14 0 0 0 1.78 3.87z"
      strokeWidth="1.5"
    />
  </svg>
)

export default Activities
